module.exports = __webpack_public_path__ + "img/opineo.334806a4.png";